<!-- @veltra/icons generated sha256:5737044d6cc566cd gen:8 source:src/svg/colorful/excel.svg -->
<script setup lang="ts">
defineOptions({ name: 'Excel' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#53d39c"
        d="M10.292 1H4.209C2.989 1 2 1.987 2 3.206v9.578c0 1.22.99 2.208 2.209 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.71c0-.497-.198-.974-.55-1.326l-1.835-1.836A1.88 1.88 0 0 0 10.292 1"
      />
      <path
        fill="#25bf79"
        d="M10.242 6.075a.375.375 0 0 0-.53 0l-1.73 1.73-1.731-1.73a.375.375 0 0 0-.53.53l1.73 1.731-1.73 1.73a.375.375 0 0 0 .53.53l1.73-1.73 1.73 1.73a.374.374 0 0 0 .53 0 .375.375 0 0 0 0-.53l-1.73-1.73 1.73-1.73a.375.375 0 0 0 0-.53m3.211-2.69-1.835-1.837a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.184 1.185h2.115a1.9 1.9 0 0 0-.499-.895"
      />
      <path
        fill="#fff"
        d="m8.511 8.149 1.73-1.73a.375.375 0 0 0-.53-.531l-1.73 1.73-1.73-1.73a.375.375 0 0 0-.53.53l1.73 1.73L5.72 9.88a.375.375 0 0 0 .53.53l1.73-1.73 1.73 1.73a.374.374 0 0 0 .53 0 .375.375 0 0 0 0-.53z"
      />
    </g>
  </svg>
</template>
